import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Image as ImageIcon, Check, Sparkles } from "lucide-react";

export const PosterSuggestDialog = ({ data, busyId, onClose, onAttach }) => (
  <Dialog open={!!data} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="poster-suggest-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2"><Sparkles className="h-4 w-4 text-purple-500" /> Brand this quotation</DialogTitle>
        <DialogDescription>
          {data?.matched
            ? `Posters that match ${data?.destination || "this trip"} — attach one in a tap.`
            : "Your latest posters — attach one to give this quote white-label branding."}
        </DialogDescription>
      </DialogHeader>
      {data && (
        (data.suggestions || []).length === 0 ? (
          <div className="rounded-xl border border-dashed border-slate-200 bg-slate-50/60 p-6 text-center text-sm text-slate-500" data-testid="poster-suggest-empty">
            <ImageIcon className="mx-auto mb-2 h-6 w-6 text-slate-300" />
            No saved posters yet. Create one in the AI Poster Maker and save it to your library.
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
            {data.suggestions.map((p) => (
              <button key={p.record_id} onClick={() => onAttach(p)} disabled={!!busyId}
                data-testid={`poster-suggest-${p.record_id}`}
                className="group relative overflow-hidden rounded-xl border-2 border-slate-100 text-left transition hover:border-purple-400 disabled:opacity-50">
                <img src={p.data?.image} alt={p.title} className="aspect-square w-full object-cover" />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-2">
                  <p className="truncate text-[11px] font-medium text-white">{p.title}</p>
                </div>
                <span className="absolute right-1.5 top-1.5 flex items-center gap-1 rounded-full bg-purple-600/90 px-2 py-0.5 text-[10px] font-semibold text-white opacity-0 transition group-hover:opacity-100">
                  {busyId === p.record_id ? "Attaching…" : <><Check className="h-3 w-3" /> Attach</>}
                </span>
              </button>
            ))}
          </div>
        )
      )}
      <p className="mt-2 text-[11px] text-slate-400">The attached poster appears as a branded banner on the customer's shared quotation page.</p>
    </DialogContent>
  </Dialog>
);
